import * as Yup from "yup"

export const PasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{6,}$/,
      'Password must be  one uppercase letter, one lowercase letter,numbers and includes special characters'
    )
    .required('Password is required'),
    confirmPassword: Yup.string()
    .required('Password is required')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
});

  